module.exports = __webpack_public_path__ + "static/img/2.3bc4718.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shop/product/2.jpg
// module id = oniV
// module chunks = 1